webpackJsonp([96961042003272],{

/***/ 198:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\n  h1, h2, h3 {\n    font-weight: 600;\n    line-height: 1.25;\n    margin: 0 0 1rem 0;\n    text-transform: capitalize;\n  }\n\n  h1 {\n    font-size: 1.5em;\n  }\n\n  h2 {\n    font-size: 1.25em;\n  }\n\n  h3 {\n    font-size: 1em;\n  }\n\n  p {\n    line-height: 1.6;\n    margin: 0 0 2em 0;\n  }\n\n  a {\n    transition: all .2s;\n    color: ', ';\n    &:hover {\n      color: ', ';\n    }\n  }\n\n  del {\n    text-decoration: line-through;\n  }\n\n  strong {\n    font-weight: 600;\n  }\n\n  em {\n    font-style: italic;\n  }\n\n  ul {\n    margin: 0 0 2em 0;\n\n    li {\n      list-style: disc;\n      list-style-position: inside;\n      line-height: 1.25;\n      &:last-child {margin: 0;}\n    }\n\n  }\n\n  ol {\n    margin: 0 0 2em 0;\n\n    li {\n      list-style: decimal;\n      list-style-position: inside;\n      line-height: 1.25;\n      &:last-child {margin: 0;}\n    }\n\n  }\n\n  hr {\n    border-style: solid;\n    border-color: ', ';\n    margin: 0 0 2em 0;\n  }\n\n  blockquote {\n    font-style: italic;\n    border-left: 4px solid ', ';\n    padding: 0 0 0 .5em;\n  }\n\n  pre {\n    margin: 0 0 2em 0;\n    border-radius: 2px;\n    background: ', ' !important;\n    span {\n      background: inherit !important;\n    }\n  }\n'], ['\n\n  h1, h2, h3 {\n    font-weight: 600;\n    line-height: 1.25;\n    margin: 0 0 1rem 0;\n    text-transform: capitalize;\n  }\n\n  h1 {\n    font-size: 1.5em;\n  }\n\n  h2 {\n    font-size: 1.25em;\n  }\n\n  h3 {\n    font-size: 1em;\n  }\n\n  p {\n    line-height: 1.6;\n    margin: 0 0 2em 0;\n  }\n\n  a {\n    transition: all .2s;\n    color: ', ';\n    &:hover {\n      color: ', ';\n    }\n  }\n\n  del {\n    text-decoration: line-through;\n  }\n\n  strong {\n    font-weight: 600;\n  }\n\n  em {\n    font-style: italic;\n  }\n\n  ul {\n    margin: 0 0 2em 0;\n\n    li {\n      list-style: disc;\n      list-style-position: inside;\n      line-height: 1.25;\n      &:last-child {margin: 0;}\n    }\n\n  }\n\n  ol {\n    margin: 0 0 2em 0;\n\n    li {\n      list-style: decimal;\n      list-style-position: inside;\n      line-height: 1.25;\n      &:last-child {margin: 0;}\n    }\n\n  }\n\n  hr {\n    border-style: solid;\n    border-color: ', ';\n    margin: 0 0 2em 0;\n  }\n\n  blockquote {\n    font-style: italic;\n    border-left: 4px solid ', ';\n    padding: 0 0 0 .5em;\n  }\n\n  pre {\n    margin: 0 0 2em 0;\n    border-radius: 2px;\n    background: ', ' !important;\n    span {\n      background: inherit !important;\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	__webpack_require__(198);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.colors.base;
	}, function (props) {
	  return props.theme.colors.highlight;
	}, function (props) {
	  return props.theme.colors.secondary;
	}, function (props) {
	  return props.theme.colors.secondary;
	}, function (props) {
	  return props.theme.colors.secondary;
	});
	
	var Body = function Body(props) {
	  return _react2.default.createElement(Wrapper, { dangerouslySetInnerHTML: props.dangerouslySetInnerHTML });
	};
	
	exports.default = Body;
	module.exports = exports['default'];

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    font-size: 2.6em;\n    font-weight: 600;\n    text-align: center;\n    margin: 0 0 2rem 0;\n  '], ['\n    font-size: 2.6em;\n    font-weight: 600;\n    text-align: center;\n    margin: 0 0 2rem 0;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    margin: 0 auto;\n    max-width: ', ';\n    padding: 3em 0 2em;\n  '], ['\n    margin: 0 auto;\n    max-width: ', ';\n    padding: 3em 0 2em;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(39);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(94);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactHelmet = __webpack_require__(72);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _siteConfig = __webpack_require__(33);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _body = __webpack_require__(170);
	
	var _body2 = _interopRequireDefault(_body);
	
	var _semanticUiReact = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var PageTemplate = function PageTemplate(_ref) {
	  var data = _ref.data;
	  var _data$contentfulPage = data.contentfulPage,
	      title = _data$contentfulPage.title,
	      id = _data$contentfulPage.id,
	      slug = _data$contentfulPage.slug,
	      body = _data$contentfulPage.body;
	
	
	  var Title = _styledComponents2.default.h1(_templateObject);
	
	  var Page = (0, _styledComponents2.default)(_semanticUiReact.Container)(_templateObject2, function (props) {
	    return props.theme.sizes.maxWidthCentered;
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        title + ' - ' + _siteConfig2.default.siteTitle
	      ),
	      _react2.default.createElement('meta', { property: 'og:title', content: title + ' - ' + _siteConfig2.default.siteTitle }),
	      _react2.default.createElement('meta', { property: 'og:url', content: '' + (_siteConfig2.default.siteUrl + _siteConfig2.default.pathPrefix) + slug + '/' })
	    ),
	    _react2.default.createElement(
	      Page,
	      { text: true },
	      _react2.default.createElement(
	        Title,
	        null,
	        title
	      ),
	      _react2.default.createElement(_body2.default, { dangerouslySetInnerHTML: { __html: body.childMarkdownRemark.html } })
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = PageTemplate;

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-js-ea9196d132992dc4219b.js